export default __webpack_public_path__ + "static/media/login.31fc6039.svg";